var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Type/Chromium",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92804678,2.787625 C5.63979727,-1.540375 12.5223548,-0.686375 15.0943314,4.369625 C13.2828694,4.370625 10.4474074,4.368625 8.91140741,4.369625 C7.79758285,4.369625 7.0779883,4.344625 6.29950877,4.755625 C5.3842963,5.238625 4.69264717,6.133625 4.45211696,7.185625 L1.92804678,2.787625 Z",
    id: "Path",
    fill: "#236CDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32840546,8.000625 C5.32840546,9.467625 6.51907992,10.660625 7.98222222,10.660625 C9.44536452,10.660625 10.636039,9.467625 10.636039,8.000625 C10.636039,6.533625 9.44536452,5.34062437 7.98222222,5.34062437 C6.51808187,5.339625 5.32840546,6.533625 5.32840546,8.000625 Z",
    id: "Path",
    fill: "#288BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01121248,11.482625 C7.52212086,11.925625 5.77852632,11.434625 4.82438986,9.782625 C4.09581287,8.522625 2.16957505,5.161625 1.29528265,3.632625 C-1.77072904,8.340625 0.871111111,14.755625 6.43624172,15.850625 L9.01121248,11.482625 Z",
    id: "Path",
    fill: "#519CFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4464094,5.339625 C11.6869864,6.495625 11.9574581,8.367625 11.1170994,9.818625 C10.4843353,10.912625 8.46328265,14.329625 7.48419493,15.983625 C13.2179961,16.337625 17.3978324,10.707625 15.5095205,5.338625 L10.4464094,5.339625 Z",
    id: "Path",
    fill: "#9AC3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromium);
export default __webpack_public_path__ + "static/media/chromium.9c9c2e25895756bc344ac52cd51ac893.svg";
export { ForwardRef as ReactComponent };